export const MITACS_BASIC_TASKS = [
    {
      id: 1,
      name: "Get client consent and educate about Mitacs program",
      prompt: "Get client consent and educate about Mitacs program",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "research",
      completed: true,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "1-1",
          name: "Schedule initial meeting with client",
          prompt:
            "Schedule initial meeting with client to discuss Mitacs program",
          completed: true,
          action: "follow_up",
        },
        {
          id: "1-2",
          name: "Prepare Mitacs program overview presentation",
          prompt:
            "Create presentation explaining Mitacs benefits and requirements",
          completed: true,
          action: "create_document",
        },
        {
          id: "1-3",
          name: "Obtain signed consent form",
          prompt: "Get client to sign consent form for Mitacs participation",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 2,
      name: "Create job description/job title for the position",
      prompt: "Create job description/job title for the position",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "create_document",
      completed: true,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "2-1",
          name: "Define role responsibilities and requirements",
          prompt:
            "Outline key responsibilities and qualifications for the position",
          completed: true,
          action: "create_document",
        },
        {
          id: "2-2",
          name: "Set salary range and benefits",
          prompt: "Determine competitive salary range and benefits package",
          completed: true,
          action: "research",
        },
        {
          id: "2-3",
          name: "Review and finalize job description",
          prompt:
            "Review job description with client and make final adjustments",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 3,
      name: "Prepare draft project proposal",
      prompt: "Prepare draft project proposal",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "create_document",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "3-1",
          name: "Research project objectives and scope",
          prompt:
            "Define clear project objectives, scope, and expected outcomes",
          completed: false,
          action: "research",
        },
        {
          id: "3-2",
          name: "Outline project timeline and milestones",
          prompt:
            "Create detailed timeline with key milestones and deliverables",
          completed: false,
          action: "create_document",
        },
        {
          id: "3-3",
          name: "Draft budget and resource requirements",
          prompt: "Prepare budget breakdown and identify required resources",
          completed: false,
          action: "create_document",
        },
        {
          id: "3-4",
          name: "Write executive summary",
          prompt:
            "Create compelling executive summary highlighting project value",
          completed: false,
          action: "create_document",
        },
      ],
    },
    {
      id: 4,
      name: "Post job description in Mitacs portal and university job board",
      prompt: "Post job description in Mitacs portal and university job board",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "submit_application",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "4-1",
          name: "Create account/login to Mitacs portal",
          prompt: "Set up or access Mitacs portal account",
          completed: false,
          action: "research",
        },
        {
          id: "4-2",
          name: "Upload job description to Mitacs portal",
          prompt: "Post job description in Mitacs RAP portal",
          completed: false,
          action: "submit_application",
        },
        {
          id: "4-3",
          name: "Post to university career services",
          prompt: "Submit job posting to university career services office",
          completed: false,
          action: "submit_application",
        },
        {
          id: "4-4",
          name: "Share on relevant department job boards",
          prompt: "Post to relevant academic department job boards",
          completed: false,
          action: "submit_application",
        },
      ],
    },
    {
      id: 5,
      name: "Find and secure academic advisor",
      prompt: "Find and secure academic advisor",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "research",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "5-1",
          name: "Identify potential advisors in relevant field",
          prompt:
            "Research professors and researchers in relevant academic field",
          completed: false,
          action: "research",
        },
        {
          id: "5-2",
          name: "Reach out to potential advisors",
          prompt:
            "Contact potential advisors to gauge interest and availability",
          completed: false,
          action: "send_email",
        },
        {
          id: "5-3",
          name: "Schedule meetings with interested advisors",
          prompt: "Set up meetings to discuss project collaboration",
          completed: false,
          action: "follow_up",
        },
        {
          id: "5-4",
          name: "Secure commitment from selected advisor",
          prompt: "Get formal commitment and signed agreement from advisor",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 6,
      name: "Submit application via Mitacs RAP portal (once all participants are ready)",
      prompt:
        "Submit application via Mitacs RAP portal (once all participants are ready)",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "submit_application",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "6-1",
          name: "Verify all required documents are complete",
          prompt:
            "Check that all application documents are finalized and ready",
          completed: false,
          action: "update_record",
        },
        {
          id: "6-2",
          name: "Confirm all participants are ready",
          prompt: "Verify client, advisor, and student are all committed",
          completed: false,
          action: "follow_up",
        },
        {
          id: "6-3",
          name: "Complete online application form",
          prompt: "Fill out all required fields in Mitacs RAP portal",
          completed: false,
          action: "submit_application",
        },
        {
          id: "6-4",
          name: "Upload all supporting documents",
          prompt:
            "Attach project proposal, job description, and other required files",
          completed: false,
          action: "submit_application",
        },
        {
          id: "6-5",
          name: "Submit final application",
          prompt: "Review and submit completed application to Mitacs",
          completed: false,
          action: "submit_application",
        },
      ],
    },
    {
      id: 7,
      name: "Get all participants to sign off and secure ORS approval",
      prompt: "Get all participants to sign off and secure ORS approval",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "7-1",
          name: "Prepare participant sign-off forms",
          prompt: "Create forms for all participants to sign",
          completed: false,
          action: "create_document",
        },
        {
          id: "7-2",
          name: "Collect signatures from client, advisor, and student",
          prompt: "Obtain signed forms from all project participants",
          completed: false,
          action: "follow_up",
        },
        {
          id: "7-3",
          name: "Submit to university ORS office",
          prompt: "Send all signed documents to Office of Research Services",
          completed: false,
          action: "submit_application",
        },
        {
          id: "7-4",
          name: "Follow up on ORS approval status",
          prompt: "Check status and address any ORS concerns or requirements",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 8,
      name: "Wait for funds to be received (minimum 6 weeks before project start)",
      prompt:
        "Wait for funds to be received (minimum 6 weeks before project start)",
      model: "gpt-4",
      isRecurring: true,
      frequency: "weekly",
      action: "follow_up",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "weekly",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "8-1",
          name: "Monitor application status weekly",
          prompt: "Check Mitacs portal for application status updates",
          completed: false,
          action: "follow_up",
          isRecurring: true,
          frequency: "weekly",
        },
        {
          id: "8-2",
          name: "Confirm receipt of funds notification",
          prompt: "Verify that funds have been approved and transferred",
          completed: false,
          action: "update_record",
        },
        {
          id: "8-3",
          name: "Coordinate project start date",
          prompt:
            "Confirm project start date aligns with fund receipt timeline",
          completed: false,
          action: "follow_up",
        },
      ],
    },
    {
      id: 9,
      name: "Complete final presentation and exit surveys",
      prompt: "Complete final presentation and exit surveys",
      model: "gpt-4",
      isRecurring: false,
      frequency: "daily",
      action: "update_record",
      completed: false,
      startDate: "",
      startTime: "",
      recurrenceType: "daily",
      recurrenceDays: [],
      emailTo: "",
      emailFrom: "",
      emailSubject: "",
      emailBody: "",
      subtasks: [
        {
          id: "9-1",
          name: "Prepare final project presentation",
          prompt:
            "Create comprehensive presentation summarizing project outcomes",
          completed: false,
          action: "create_document",
        },
        {
          id: "9-2",
          name: "Schedule presentation with stakeholders",
          prompt:
            "Set up meeting to present final results to client and advisor",
          completed: false,
          action: "follow_up",
        },
        {
          id: "9-3",
          name: "Complete Mitacs exit survey",
          prompt: "Fill out required Mitacs program exit survey",
          completed: false,
          action: "update_record",
        },
        {
          id: "9-4",
          name: "Submit final project report",
          prompt: "Prepare and submit final project report to Mitacs",
          completed: false,
          action: "submit_application",
        },
      ],
    },
  ];
